export default __webpack_public_path__ + "static/portfolio_gallery_20-494ec3d4f759ff1687224ddfea610530.jpg";